import { computed, ref } from 'vue';
import { CloseOutlined } from '@ant-design/icons-vue';
export default {
  name: 'XEditorLayout',
  components: {
    CloseOutlined
  },
  props: {
    width: {
      type: [String, Number],
      default: '400px'
    },
    labelWidth: {
      type: [String, Number, Object],
      default: '120px'
    },
    rules: {
      type: Object
    },
    model: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      default: ''
    }
  },
  setup(props, {
    expose
  }) {
    const formRef = ref();
    const labelStyle = computed(() => {
      if (typeof props.labelWidth === 'object') {
        return props.labelWidth;
      }
      return {
        style: `width: ${props.labelWidth}`
      };
    });

    // validate 验证表单
    const validate = async () => {
      return new Promise(resolve => {
        if (!formRef.value) {
          return resolve(false);
        }
        formRef.value.validate().then(data => resolve(data)).catch(() => {
          const els = document.getElementsByClassName('ant-form-item-has-error');
          if (els && els.length > 0 && els[0].scrollIntoView) {
            els[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
          resolve(false);
        });
      });
    };
    expose({
      validate
    });
    return {
      labelStyle,
      formRef,
      validate
    };
  }
};